import { create } from 'zustand';
import { Filter } from '@libs/models/common';
import { fetchLinesOfBusinessList } from '@libs/api/linesOfBusiness';
import { LineOfBusinessListItem } from '@libs/models/linesOfBusiness';

type InitialState = {
  initialized: boolean;
  loadingList: boolean;
  linesOfBusiness: LineOfBusinessListItem[];
  page: number;
  perPage: number;
  total: number;
  load: (filters?: Filter[], page?: number, perPage?: number) => Promise<void>;
};

export const useLinesOfBusinessListStore = create<InitialState>()((set) => ({
  initialized: false,
  loadingList: false,
  linesOfBusiness: [],
  page: 1,
  perPage: 50,
  total: 0,

  load: async (filters, page = 1, perPage = 50) => {
    set({ loadingList: true });
    try {
      const resp = await fetchLinesOfBusinessList({ filters, page, size: perPage });
      set({
        loadingList: false,
        initialized: true,
        linesOfBusiness: resp.items,
        page,
        perPage,
        total: resp.totalCount,
      });
    } finally {
      set({ loadingList: false, initialized: true });
    }
  },
}));
